var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"entrypoint"},[_c('form',{staticClass:"dropzone",attrs:{"action":_vm.url,"name":"dropzone","id":_vm.id,"numMaxArquivos":_vm.numMaxArquivos}})])
}
var staticRenderFns = []

export { render, staticRenderFns }